export default __webpack_public_path__ + "static/BritishIslesChritianHistory-5481671b2ca7abe6582583cc4a5c35e9.jpg";